import { Breadcrumb } from "antd";
import Container from "../../components/general/container/Container";
import ProductGrid from "../../components/general/productGrid.tsx/ProductGrid";
import { useEffect, useState } from "react";
import { IProduct } from "../../models/product";
import http from "../../api/api";
import { Link } from "react-router-dom";

const MostSelling = () => {
  const [products, setProducts] = useState<IProduct[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const getData = async () => {
      try {
        const { data } = await http.get("/products/best-seller");
        setProducts(data.data);
      } catch (err) {
      } finally {
        setLoading(false);
      }
    };
    getData();
  }, []);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  return (
    <>
      <Container>
        <Breadcrumb
          separator={<div className="text-[24px]">{`>`}</div>}
          items={[
            {
              title: (
                <Link className="text-[24px] p-[24px] hover:h-auto" to={"/"}>
                  الرئيسية
                </Link>
              ),
            },
            {
              title: "الأكثر مبيعاً",
              className: "text-[24px]",
            },
          ]}
        />
        <div className="mt-[70px]">
          <ProductGrid products={products} loading={loading} />
        </div>
      </Container>
    </>
  );
};

export default MostSelling;
